import OktaAuth from '@okta/okta-auth-js';
import oktaConfig from '../config/oktaConfig';
import {groupNameEnv} from '../config/clientConfig';

let config = {
    pkce: oktaConfig.oidc.pkce,
    issuer: oktaConfig.oidc.issuer,
    clientId: oktaConfig.oidc.clientId,
    redirectUri: oktaConfig.oidc.redirectUri
};

let authClient = new OktaAuth(config);

export const getUserInfo = async () => {
    const idToken = await authClient.tokenManager.get('idToken');

    if (idToken) {
        const info = authClient.token.decode(idToken.idToken);

        if (info.payload) {
            return info.payload;
        }
    } else {
        const accessToken = await authClient.tokenManager.get('accessToken');

        if (accessToken) {
            authClient.signOut({
                postLogoutRedirectUri: window.location.origin + '/logged_out'
            });
        } else {
            return;
        }
    }
}

const groupNamePrefix = 'DevPortal.' + groupNameEnv;

const getUserType = async () => {
    const resp = await getUserInfo();
    const applicationGroups =  (resp && resp.applicationGroups) || []
    // const applicationGroups = ["PartnerAdmin", "DevPortal.PRE.InternalBusAdmin"]

    if (applicationGroups.some(groups => groups.includes(groupNamePrefix + 'InternalTechAdmin'))) {
        return "InternalTechAdmin"
    }
    if (applicationGroups.some(groups => groups.includes(groupNamePrefix + 'InternalBusAdmin'))) {
        return "InternalBusAdmin"
    }
    if (applicationGroups.some(groups => groups.includes(groupNamePrefix + 'PartnerAdmin'))) {
        return "PartnerAdmin"
    }
    if (applicationGroups.some(groups => groups.includes(groupNamePrefix + 'InternalDeveloper'))) {
        return "InternalDeveloper"
    }
    return null
}

export const isInternalTechAdmin = async () => await getUserType() === 'InternalTechAdmin'

export const isInternalBusAdmin = async () => await getUserType() === 'InternalBusAdmin'

export const isExternalPartnerAdmin = async () => await getUserType() === 'PartnerAdmin'

export const isInternalDeveloper = async () => await getUserType() === 'InternalDeveloper'

export const hasExternalRole = async () => {
    const resp = await getUserInfo();
    const applicationGroups =  (resp && resp.applicationGroups) || []
    return applicationGroups.some(groups => groups.includes(groupNamePrefix + 'PartnerAdmin'))
}

export const hasInternalRoles = async () => {
    const resp = await getUserInfo();
    const applicationGroups =  (resp && resp.applicationGroups) || []
    return applicationGroups.some(groups =>groups.includes(groupNamePrefix + 'Internal'))
    // return applicationGroups.some(groups => ['InternalTechAdmin', 'InternalBusAdmin', 'InternalTechAdmin'].some(role => groups.includes(role)))
}

export const hasInternalAndExternalRoles = async () => await hasExternalRole() && await hasInternalRoles()